import api from 'api';

import { defaultPagination } from './general';

const handleData = (data) => {
  const body = data;
  if (data.address) {
    body.address = {
      ...data.address,
      city: data.address.city.name,
      state: data.address.state.name,
    };
  }
  return body;
};

type GetCompanyType = {id: number | string}
export const getUserCompany = async () => api().get('/company');

export const listCompanies = async (params) => api().get('/companies', { params: { ...defaultPagination, ...params } });

export const getCompany = async ({ id }: GetCompanyType) => api().get(`/companies/${id}`);

export const createCompany = async ({ data }: any) => api().post('/companies', handleData(data));

export const updateCompany = async ({ id, data }: any) => api().put(`/companies/${id}`, handleData(data));

export const updateUserCompany = async ({ data }) => api().put('/company', handleData(data));
